import { Content } from '../DynamicDetails/styles';

export const Container = Content;
